let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("leIbB"), load("aIkc8")]).then(() => parcelRequire('aNZDi'));